
const YOUTUBE_REGEX = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
const VIMEO_REGEX = /(?:https?:\/\/)?(?:www\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|)(\d+)/;

// Standard-Platzhalter, falls kein spezifisches Thumbnail generiert werden kann.
const DEFAULT_VIDEO_THUMBNAIL = 'https://placeholder.pics/svg/300x240/DEDEDE/555555/Video?label=Video';

/**
 * Generiert eine Thumbnail-URL für eine gegebene Video-URL.
 * Unterstützt YouTube und Vimeo.
 * @param videoUrl Die URL des Videos.
 * @param fallbackThumbnail Die URL zum Platzhalterbild, falls kein Thumbnail gefunden wird.
 * @returns Eine Promise, die zur Thumbnail-URL auflöst.
 */
export async function getVideoThumbnail(
  videoUrl: string,
  fallbackThumbnail: string = DEFAULT_VIDEO_THUMBNAIL
): Promise<string> {
  if (!videoUrl || videoUrl.trim() === '') {
    return fallbackThumbnail;
  }

  // YouTube-Video-IDs extrahieren und Thumbnail-URL generieren
  const youtubeMatch = videoUrl.match(YOUTUBE_REGEX);
  if (youtubeMatch && youtubeMatch[1]) {
    // hqdefault.jpg ist eine gute Qualität, mqdefault.jpg ist kleiner
    return `https://img.youtube.com/vi/${youtubeMatch[1]}/hqdefault.jpg`;
  }

  // Vimeo-Video-IDs extrahieren und Thumbnail über oEmbed API abrufen
  const vimeoMatch = videoUrl.match(VIMEO_REGEX);
  if (vimeoMatch && vimeoMatch[1]) {
    try {
      const response = await fetch(`https://vimeo.com/api/oembed.json?url=${encodeURIComponent(videoUrl)}`);
      if (!response.ok) {
        console.warn(`Fehler beim Abrufen des Vimeo oEmbed für ${videoUrl}: ${response.status}`);
        return fallbackThumbnail;
      }
      const data = await response.json();
      // Vimeo bietet verschiedene Thumbnail-Größen, thumbnail_url ist oft eine gute Wahl
      return data.thumbnail_url || fallbackThumbnail;
    } catch (error) {
      console.error(`Fehler beim Abrufen des Vimeo-Thumbnails für ${videoUrl}:`, error);
      return fallbackThumbnail;
    }
  }

  // Fallback für andere Video-URLs (z.B. direkte MP4-Links, für die clientseitige Generierung komplexer ist)
  // console.warn(`Keine spezifische Thumbnail-Generierung für Video-URL: ${videoUrl}. Fallback wird verwendet.`);
  return fallbackThumbnail;
}
